import { Fragment, useRef, useState } from 'react'

import useClickOutside from '~/shared/hooks/useClickOutside.hook'

import HeaderMenuItems from '~/tutor-on-demand/components/Header/HeaderMenuItems/HeaderMenuItems'

import HeaderMenuButton from './HeaderMenuButton'

export default function HeaderMenu(): React.ReactElement {
  const [isOpen, setIsOpen] = useState(false)

  const ref = useRef<HTMLButtonElement>(null)
  useClickOutside(ref, () => setIsOpen(false))

  return (
    <Fragment>
      <HeaderMenuButton onClick={() => setIsOpen((prevState) => !prevState)} ref={ref} />
      <HeaderMenuItems isOpen={isOpen} />
    </Fragment>
  )
}
